import { useMemo } from 'react';

import { Box } from '@mui/material';

import { EmptyState } from '@/components/EmptyState';

import { MiniTableType } from '../types';
import MiniTable from './components/MiniTable';

type MiniTableContainerProps = {
  // height?: number;
  tables: MiniTableType[];
};
const MiniTablesContainer = ({ tables }: MiniTableContainerProps) => {
  const columns = useMemo(() => {
    const columns: [MiniTableType[], MiniTableType[]] = [[], []];

    for (const table of tables) {
      const index = tables.indexOf(table);
      if (index % 2 === 0) {
        columns[0].push(table);
      } else {
        columns[1].push(table);
      }
    }
    return columns;
  }, [tables]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        flexDirection: {
          xs: 'column',
          md: 'row'
        },
        flex: 1,
        minHeight: '250px',
        maxHeight: '650px',
        overflowY: 'auto',
        height: '100%'
      }}
    >
      {tables.length === 0 && (
        <Box sx={{ display: 'flex', flex: 1 }}>
          <EmptyState />
        </Box>
      )}
      {columns.map((tables, colIdx) => {
        const boxKey = tables.map(t => t.name).join('-') || `column-${colIdx}`;

        return (
          <Box
            key={boxKey}
            sx={{ display: 'flex', flex: 1, flexDirection: 'column', gap: '12px' }}
          >
            {tables.map(table => (
              <MiniTable
                key={table.name}
                table={table}
              />
            ))}
          </Box>
        );
      })}
    </Box>
  );
};

export default MiniTablesContainer;
